import { Item } from "../models/item";
import { CartItem } from "./cartItem";

export function convertItemToCartItem(item: Item, seqNo: number): CartItem {
    const qty = 1;
    const tprice = (item.sprice * qty) / (1 + item.tax);
    const ttax = tprice * item.tax;

    const theCartItem = {
        ...item,
        seqNo: seqNo,
        // id: item.id,
        // code: item.code,
        // name: item.name,
        // tax: item.tax,
        // sprice: item.sprice,
        // scurr: item.scurr,
        price: item.sprice / (1 + item.tax),
        qty: qty,
        tprice: tprice,
        ttax: ttax
    };

    // console.log('convertItemToCartItem: ', theCartItem);

    return theCartItem;
}

export function calculateCartProps(theCartItems: CartItem[]) {
    // console.log('calculateCartProps: ', theCartItems);
    const cartTotal = theCartItems.reduce((sum, item) => sum = sum + item.tprice, 0);
    const cartTax8 = theCartItems.filter(item => item.tax === 0.08).reduce((sum, item) => sum = sum + item.ttax, 0);
    const cartTax18 = theCartItems.filter(item => item.tax === 0.18).reduce((sum, item) => sum = sum + item.ttax, 0);
    const cartGrandTotal = cartTotal + cartTax8 + cartTax18;
    return {
        cartTotal: +cartTotal.toFixed(2),
        cartTax8: +cartTax8.toFixed(2),
        cartTax18: +cartTax18.toFixed(2),
        cartGrandTotal: +cartGrandTotal.toFixed(2)
    }
}

export function changeQty(theCartItem: CartItem, newQty: number) {
    // console.log('changeQty: ', newQty)
    const updatedCartItem = {
        ...theCartItem,
        qty: newQty,
        tprice: theCartItem.price * newQty,
        ttax: theCartItem.price * newQty * theCartItem.tax
    };
    // console.log('changeQty: ', updatedCartItem)
    return updatedCartItem;
}

export function addOne(theCartItem: CartItem): CartItem {
    // const updatedCartItem = {
    //     ...theCartItem,
    //     qty: theCartItem.qty + 1,
    //     tprice: theCartItem.tprice + theCartItem.price,
    //     ttax: theCartItem.tprice * theCartItem.tax
    // };
    // return updatedCartItem;
    // console.log('addOne: ', theCartItem);
    return changeQty(theCartItem, theCartItem.qty + 1);
}

export function removeOne(theCartItem: CartItem): CartItem {
    // return {
    //     ...theCartItem,
    //     qty: theCartItem.qty - 1,
    //     tprice: theCartItem.tprice - theCartItem.price,
    //     ttax: theCartItem.tprice * theCartItem.tax
    // };
    return changeQty(theCartItem, theCartItem.qty - 1);
}

export function invert(theCartItem: CartItem): CartItem {
    // return {
    //     ...theCartItem,
    //     qty: theCartItem.qty * (-1),
    //     tprice: theCartItem.tprice * (-1),
    //     ttax: theCartItem.ttax * (-1)
    // };
    return changeQty(theCartItem, theCartItem.qty * (-1));
}

export function addOneItem(item: Item, theCartItems: CartItem[]): CartItem[] {
    const isAvailable = theCartItems.findIndex(citem => item.id === citem.id);
    if (isAvailable === -1) {
        const newCartItem = convertItemToCartItem(item, theCartItems.length );
        return [...theCartItems, newCartItem];
    } else {return theCartItems.map(citem => {
        if(citem.id === item.id) {
            return addOne(citem);
        } else {
            return citem;
        }
    })}
} 

export function changeItemQty(cartItem: CartItem, newQty: number,  theCartItems: CartItem[]): CartItem[] {
    return theCartItems.map(citem => {
        if(citem.id === cartItem.id) {
            return changeQty(citem, newQty);
        } else {
            return citem;
        }
    });
}

export function removeCartItem(cartItem: CartItem, theCartItems: CartItem[]): CartItem[] {
    return theCartItems
        .filter(citem => citem.id !== cartItem.id)
        .map((citem, ind) => {
            return {
                ...citem,
                seqNo: ind + 1
            };
        })
}